/* OutboundSyslogAdvPrefsRenderer.js */

"use strict";
const uiCore = require("@gluenetworks/steve_ui_core");
// const InputTextControl = uiCore.Control.Textfield.InputText;
const InputPasswordControl = uiCore.Control.Textfield.InputPassword;
const ButtonControl = uiCore.Control.Action.Button;
const InputNumberControl = uiCore.Control.Textfield.InputNumber;
const InputRadioControl = uiCore.Control.OptionSelection.Single.InputRadio;
const TextAreaControl = uiCore.Control.Textfield.Textarea;
const CheckboxControl = uiCore.Control.Boolean.InputCheckbox;

const textEditor = require('./slickeditors/InputTextEditor');
const formatters = require('./formatters/index');

const _ = require("lodash");

/* global Slick */

class OutboundSyslogAdvPrefsRenderer {
    constructor(model) {
        this._model = model;
        this._uiUtils = model._uiUtils;
        this._rootElem = document.createElement("adv-prefs");

        this._heading = document.createElement("h2");
        this._heading.innerText = "Syslog Server Configuration";

        this._container = document.createElement("div");
        this._container.classList.add("adv-prefs-container");

        this._portInput = new InputNumberControl({
            theme: "dark", disabled: true, min: 1, max: 65535
        });
        this._protocolInput = new InputRadioControl({
            darkTheme: true,
            horizontal: true,
            options: [
                {
                    label: "UDP",
                    value: "udp"
                },
                {
                    label: "TCP",
                    value: "tcp"
                },
                {
                    label: "TLS",
                    value: "tls"
                }
            ],
            value: "udp",
            disabled: true
        });
        this._timeoutInp = new InputNumberControl({ theme: "dark", disabled: true});

        this._clientTlsKeyInput = new InputPasswordControl({ darkTheme: true, disabled: true, placeholder: "Enter Client TLS Key" });
        this._clientTlsCertificateInput = new TextAreaControl({ darkTheme: true, disabled: true });

        this._slickContainer = document.createElement("div");
        this._slickContainer.classList.add("slick-container");

        this._slickTable = undefined;
        this._moveRowsPlugin = undefined;

        this._skipServerIdentityTestCheckbox = new CheckboxControl({
            darkTheme: true,
            labelShown: true,
            label: "Skip Server Identity Check",
            title: "Skip Server Identity Check",
            disabled: true
        });

        this._container.appendChild(this._uiUtils.wrapElement(
            this._portInput.renderer.getRootElement(),
            "Destination Port",
            "input-container"
        ));
        this._container.appendChild(this._uiUtils.wrapElement(
            this._protocolInput.renderer.getRootElement(),
            "Protocol",
            "input-container"
        ));
        this._container.appendChild(this._uiUtils.wrapElement(
            this._timeoutInp.renderer.getRootElement(),
            "Timeout (ms)",
            "timeout-input-container"
        ));

        this._container.appendChild(this._uiUtils.wrapElement(
            this._clientTlsKeyInput.renderer.getRootElement(),
            "Client TLS Key",
            "certs-container"
        ));

        this._container.appendChild(this._uiUtils.wrapElement(
            this._clientTlsCertificateInput.renderer.getRootElement(),
            "Client TLS Certificate",
            "certs-container"
        ));
        this._container.appendChild(this._uiUtils.wrapElement(
            this._slickContainer,
            "Server TLS Certificates",
            "certs-container"
        ));

        this._testSyslogButton = new ButtonControl({ label: "Test Syslog Configuration", darkTheme: true, class: "test-config-btn" });
        this._cancelButton = new ButtonControl({ label: "Cancel", darkTheme: true });
        this._saveButton = new ButtonControl({ label: "Back", active: true, darkTheme: true });
        this._controlButtonsContainer = document.createElement("div");
        this._controlButtonsContainer.classList.add("control-buttons");
        this._controlButtonsContainer.appendChild(this._testSyslogButton.renderer.getRootElement());
        this._controlButtonsContainer.appendChild(this._cancelButton.renderer.getRootElement());
        this._controlButtonsContainer.appendChild(this._saveButton.renderer.getRootElement());


        this._rootElem.appendChild(this._heading);
        this._rootElem.appendChild(this._container);
        this._rootElem.appendChild(this._controlButtonsContainer);

        this._addNewRowButton = new ButtonControl({
            label: "Add Certificate+",
            active: true,
            disabled: true
        });

        this._columns = [
            {
                id: "order",
                width: 10,
                name: "",
                //field: "order",
                behavior: "selectAndMove",
                asyncPostRender: function (node) {
                    node[0].setAttribute('title', 'Reorder');
                },
                selectable: false,
                resizable: false,
                cssClass: "cell-reorder dnd centered"
            },
            {
                id: "certificate",
                name: "Certificate",
                field: "certificate",
                toolTip: "Server TLS Certificte",
                // formatter: formatters.descriptionFormatter,
                editor: textEditor,
                width: 650
            },
            {
                id: "delete",
                width: 50,
                name: "Action",
                behavior: "deleteRow",
                selectable: false,
                toolTip: "Delete the custom field",
                formatter: formatters.deleteButtonFormatter,
                // asyncPostRender: this._deleteCellAddTooltips.bind(this),
                cssClass: "cell-delete centered",
                headerCssClass: "centered"
            }
        ];

        this._tableOptions = {
            editable: true,
            enableCellNavigation: true,
            enableAsyncPostRender: true,
            forceFitColumns: true,
            autoHeight: true,
            autoEdit: true,
            resizable: true,
            rowHeight: 36,
            enableTextSelectionOnCells: true,
            selectedCellCssClass: "selected-cell"
        };

        this._onSlickClick = _.debounce(this._onSLickClick.bind(this), 500);
        this._onSlickdblClick = this._onSlickdblClick.bind(this);
        this._onWindowResized = _.debounce(this._onWindowResized.bind(this), 100);
        this._setCertsOnSlickChanges = this._setCertsOnSlickChanges.bind(this);
        this._onRowCountChange = this._onRowCountChange.bind(this);
        this._onRowChange = this._onRowChange.bind(this);
        this._onCellChange = this._onCellChange.bind(this);

    }

    render() {
        if(this._rootElem) {
            setTimeout(() => {
                this._slickDataView = new Slick.Data.DataView();
                this._slickDataView.setItems(this.model.generateSlickData(this.model._advData.syslogServerTlsServerCerts || []));
                if (!this.model._enabled) {
                    this._tableOptions.editable = false;
                }
                this._slickTable = new Slick.Grid(
                    this._slickContainer,
                    this._slickDataView,
                    this._columns,
                    this._tableOptions
                );

                this._slickContainer.appendChild(this._createNoDataPlaceholder());
                this._toggleNoDataPlaceholder(!this._slickDataView.getItems().length);

                this._slickTable.setSelectionModel(new Slick.RowSelectionModel());
                this._registerRowMovePlugin(this._slickTable, this._slickDataView);

                const _slickFooterContainer = document.createElement("div");
                _slickFooterContainer.classList.add("add-new-row");
                _slickFooterContainer.appendChild(this._skipServerIdentityTestCheckbox.renderer.getRootElement());
                _slickFooterContainer.appendChild(this._addNewRowButton.renderer.getRootElement());

                this._slickContainer.appendChild(_slickFooterContainer);

                // this._slickContainer.appendChild(
                //     this._uiUtils.wrapElement(
                //         ,
                //         null,
                //         "add-new-row"
                //     )
                // );
                
                this._toggleActions(this.model.isDirty());
                this._setData();
                this._toggleTimeout();
                this._toggleCerts();
                this._toggleReadOnly();

                this._registerListeners();
                _.delay(() => {
                    this._slickTable.resizeCanvas();
                }, 20);
                
            }, 100);
            
        }
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    _registerListeners() {
        this._unregisterListeners();
        this._portInput.on("UserValue", this._onPort = this._onPort.bind(this));
        this._protocolInput.on("UserValue", this._onProtocol = this._onProtocol.bind(this));
        this._timeoutInp.on("UserValue", this._onTimeout = this._onTimeout.bind(this));
        this._clientTlsCertificateInput.on("UserValue", this._onClientCert = this._onClientCert.bind(this));
        this._clientTlsKeyInput.on("UserValue", this._onClientKey = this._onClientKey.bind(this));
        this._skipServerIdentityTestCheckbox.on("UserValue", this._onSkipServerIdentityCheck = this._onSkipServerIdentityCheck.bind(this));

        this._testSyslogButton.on("UserClick", this._onTestSyslog = this._onTestSyslog.bind(this));
        this._saveButton.on("UserClick", this._onSave = this._onSave.bind(this));
        this._cancelButton.on("UserClick", this._onCancel = this._onCancel.bind(this));

        this._addNewRowButton.on("UserClick", this._onAddNewRow = this._onAddNewRow.bind(this));
        this._registerSlickListeners();
    }

    _registerSlickListeners() {
        if (this._slickTable) {
            // console.log(this._slickTable);
            window.addEventListener("resize", this._onWindowResized);
            this._slickTable.onClick.subscribe(this._onSlickClick = this._onSLickClick.bind(this));
            this._slickTable.onDblClick.subscribe(this._onSlickdblClick);
            this._slickDataView.onRowCountChanged.subscribe(this._onRowCountChange);
            this._slickDataView.onRowsChanged.subscribe(this._onRowChange);
            this._slickTable.onCellChange.subscribe(this._onCellChange);
        }
    }

    _unregisterListeners() {
        this._portInput.removeAllListeners("UserValue");
        this._protocolInput.removeAllListeners("UserValue");
        this._timeoutInp.removeAllListeners("UserValue");
        this._clientTlsCertificateInput.removeAllListeners("UserValue");
        this._clientTlsKeyInput.removeAllListeners("UserValue");
        this._skipServerIdentityTestCheckbox.removeAllListeners("UserValue");

        this._testSyslogButton.removeAllListeners("UserClick");
        this._saveButton.removeAllListeners("UserClick");
        this._cancelButton.removeAllListeners("UserClick");
        this._addNewRowButton.removeAllListeners("UserClick");

        this._unregisterSlickListeners();
    }

    _unregisterSlickListeners() {
        if (this._slickTable) {
            this._slickTable.onClick.unsubscribe(this._onSLickClick);
            this._slickTable.onDblClick.unsubscribe(this._onSlickdblClick);
            this._slickDataView.onRowCountChanged.unsubscribe(this._onRowCountChange);
            this._slickDataView.onRowsChanged.unsubscribe(this._onRowChange);
            this._slickTable.onCellChange.unsubscribe(this._onCellChange);
        }
        window.removeEventListener("resize", this._onWindowResized);
    }

    /* Event handlers */

    _onCellChange(e, args) {
        this._setCertsOnSlickChanges(args.grid);
    }
    _onRowCountChange(e, {/*previous,*/ current/*, dataView, callingOnRowsChanged*/ }) {
        this._setCertsOnSlickChanges(this._slickTable);
        if (current !== undefined) {
            this._toggleNoDataPlaceholder(!current);
        }
    }
    _onRowChange(/*e, {/*previous,** / current/*, dataView, callingOnRowsChanged** / }*/) {
        // this._setCertsOnSlickChanges(this._slickTable);
        // if (current !== undefined) {
        //     this._toggleNoDataPlaceholder(!current);
        // }
        // this._refreshSlickGrid();
        this._setCertsOnSlickChanges();
    }

    _onSLickClick(e, args) {
        const { row, cell, grid } = args;
        const cellid = grid.getColumns()[cell].id;
        if (cellid === "delete") {
            const dataView = grid.getData();
            const certs = dataView.getItems();
            // console.log("delete");
            certs.splice(row, 1); // Does inplace edit - Mutates
            dataView.setItems(certs);
            this._refreshSlickGrid();
        }
    }

    _onSlickdblClick(/*e, args*/) {
        // console.log("called", e, args);
    }

    _onWindowResized() {
        this._slickTable.resizeCanvas();
    }


    _onPort(val) {
        this.model._updatedData.syslogServerPort = val;
        this._toggleActions(this.model.isDirty());
    }

    _onProtocol(val) {
        this.model._updatedData.syslogServerProtocol = val;
        this._toggleActions(this.model.isDirty());
        this._toggleTimeout();
        this._toggleCerts();
    }

    _onTimeout(val) {
        this.model._updatedData.syslogServerTcpTimeout = val;
        this._toggleActions(this.model.isDirty());
    }

    _onClientKey(val) {
        this.model._updatedData.syslogServerTlsClientKey = val;
        this._toggleActions(this.model.isDirty());
    }

    _onClientCert(val) {
        this.model._updatedData.syslogServerTlsClientCert = val;
        this._toggleActions(this.model.isDirty());
    }

    _onSkipServerIdentityCheck(val) {
        this.model._updatedData.allowUnauthorizedServerCertificates = val;
        this._toggleActions(this.model.isDirty());
    }

    _onTestSyslog() {
        this._testSyslogButton.setDisabled(true);
        this._testSyslogButton.setLabel("Testing Syslog Configuration");
        const _testBtnElem = this._testSyslogButton.renderer.getRootElement();
        _testBtnElem.classList.add("loading");
        setTimeout(() => {
            this._model.testSyslog().finally(() => {
                this._testSyslogButton.setDisabled(false);
                this._testSyslogButton.setLabel("Test Syslog Configuration");
                _testBtnElem.classList.remove("loading");
            });
        }, 50);
    }

    _onSave() {
        setTimeout(() => {
            this.model.resolvePopup(this.model._updatedData);
        }, 100);
    }

    _onCancel() {
        this.model.closePopUp();
    }

    _onAddNewRow() {
        const id = Math.floor((Math.random() * 100)) + new Date().getTime();
        const row = {
            id,
            certificate: ""
        };
        this._slickDataView.addItem(row);
        this._refreshSlickGrid();
    }

    /*Event handlers end */

    _setCertsOnSlickChanges() {
        const slickData = this._slickDataView.getItems().filter(item => !!item.certificate);
        this.model._updatedData.syslogServerTlsServerCerts = slickData.map(item => item.certificate);
        this._toggleActions(this.model.isDirty());
    }

    _refreshSlickGrid() {
        this._slickDataView.refresh();
        this._slickTable.invalidateAllRows();
        this._slickTable.resizeCanvas();
    }
    _toggleReadOnly() {
        if(this.model._enabled) {
            this._portInput.setDisabled(false);
            this._protocolInput.setDisabled(false);
            this._timeoutInp.setDisabled(false);
            this._clientTlsCertificateInput.setDisabled(false);
            this._clientTlsKeyInput.setDisabled(false);
            this._addNewRowButton.setDisabled(false);
            this._skipServerIdentityTestCheckbox.setDisabled(false);
        }
    }
    _toggleActions(toDisable) {
        this._saveButton.setDisabled(toDisable);
        // this._cancelButton.setDisabled(toDisable);
    }

    _toggleTimeout() {
        const inpCont = document.querySelector('.timeout-input-container');
        if (this._protocolInput.value !== "udp") {
            inpCont.classList.remove("hidden");
        } else {
            inpCont.classList.add("hidden");
        }
    }

    _toggleCerts() {
        const inps = document.querySelectorAll('.certs-container');
        if (this._protocolInput.value !== "tls") {
            inps.forEach(inp => {
                inp.classList.add('hidden');
            });
        } else {
            inps.forEach(inp => {
                inp.classList.remove('hidden');
            });
            this._slickTable.resizeCanvas();
        }
    }

    _setData() {
        /*
            syslogServerPort
            syslogServerProtocol
            syslogServerTcpTimeout
            syslogServerTlsClientCert
            syslogServerTlsClientKey
            allowUnauthorizedServerCertificates
        */
        this._portInput.setValue(this.model._advData.syslogServerPort);
        this._protocolInput.setValue(this.model._advData.syslogServerProtocol || "udp");
        this._timeoutInp.setValue(this.model._advData.syslogServerTcpTimeout);
        this._clientTlsCertificateInput.setValue(this.model._advData.syslogServerTlsClientCert);
        this._clientTlsKeyInput.setValue(this.model._advData.syslogServerTlsClientKey);
        this._skipServerIdentityTestCheckbox.setValue(this.model._advData.allowUnauthorizedServerCertificates);
    }

    _registerRowMovePlugin(grid, dataView) {
        const moveRowsPlugin = new Slick.RowMoveManager({
            cancelEditOnDrag: true
        });
        // const sortingComparator = this._model.CustomFieldsEntity.getSortingComparator("order");

        moveRowsPlugin.onBeforeMoveRows.subscribe(function (e, { insertBefore, rows }) {
            rows = [...rows].sort();
            if (
                _.first(rows) === insertBefore ||
                _.last(rows) === insertBefore - 1
                // _.get(dataView.getItem(insertBefore), "inherited")
            ) {
                e.stopPropagation();
                return false;
            }
            return true;
        });
        moveRowsPlugin.onMoveRows.subscribe(function (e, args) {
            let extractedRows = [], left, right;
            let rows = args.rows;
            let insertBefore = args.insertBefore;
            let data = dataView.getItems();
            left = data.slice(0, insertBefore);
            right = data.slice(insertBefore, data.length);

            rows.sort(function (a, b) { return a - b; });

            for (let i = 0; i < rows.length; i++) {
                extractedRows.push(data[rows[i]]);
            }

            rows.reverse();

            for (let i = 0; i < rows.length; i++) {
                let row = rows[i];
                if (row < insertBefore) {
                    left.splice(row, 1);
                } else {
                    right.splice(row - insertBefore, 1);
                }
            }

            data = left.concat(extractedRows.concat(right));

            let selectedRows = [];
            for (let i = 0; i < rows.length; i++) {
                selectedRows.push(left.length + i);
            }
            dataView.setItems(data);
            grid.resetActiveCell();
            grid.setSelectedRows(selectedRows);
            grid.invalidateAllRows();
            grid.resizeCanvas();
        });

        grid.registerPlugin(moveRowsPlugin);
    }

    _createNoDataPlaceholder(/*msg, veil = false*/) {
        const noDataPlaceholder = document.createElement("div");
        noDataPlaceholder.classList.add("no-data-placeholder");
        noDataPlaceholder.innerText = "No certificates to display";
        return noDataPlaceholder;
    }

    _toggleNoDataPlaceholder(state) {
        this._slickContainer.classList.toggle("empty", state);
    }
}

module.exports = OutboundSyslogAdvPrefsRenderer;